const SvgArrowUp = () => <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 32 32">
    <path d="M16 9.333 24 20H8z" />
  </svg>;
export default SvgArrowUp;